/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text } from '@blend/enterprise-components';

export namespace HighlightText {
  export interface Props extends Text.Props {
    text: string;
    highlight: string;
    'data-it': string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: 2,
  },
});

export const HighlightText: React.FC<HighlightText.Props> = ({ 'data-it': dataIt, text, highlight, ...rest }) => {
  let highlightIndex = -1;
  if (highlight.length > 0 && text.length > 0) {
    highlightIndex = text.toLowerCase().indexOf(highlight.toLowerCase());
  }
  if (highlightIndex === -1) {
    return (
      <Text {...rest} data-it={`${dataIt}-NoMatch`} displayBlock={false} weight="medium">
        {text}
      </Text>
    );
  }

  const beforeHighlight = text.slice(0, highlightIndex);
  const highlightedRegion = text.slice(highlightIndex, highlightIndex + highlight.length);
  const afterHighlight = text.slice(highlightIndex + highlight.length);

  return (
    <div data-it={`${dataIt}-HighlightContainer`} className={css(styles.wrapper)}>
      <Text {...rest} displayBlock={false} weight="medium" data-it={`${dataIt}-BeforeHighlight`}>
        {beforeHighlight}
      </Text>
      <Text {...rest} displayBlock={false} weight="bold" data-it={`${dataIt}-HighlightedText`}>
        {highlightedRegion}
      </Text>
      <Text {...rest} displayBlock={false} weight="medium" data-it={`${dataIt}-AfterHighlight`}>
        {afterHighlight}
      </Text>
    </div>
  );
};
